import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    projects: [],
    selectedProjectId: null,
    selectedRegion: '',
    fetching: true
  },
  mutations: {
    setProjects (state, projects) {
      state.projects = projects
    },
    setSelectedProjectId (state, id) {
      state.selectedProjectId = Number(id)
    },
    setSelectedRegion (state, region) {
      state.selectedRegion = region
    }
  },
  actions: {
    fetch ({ state, commit }, domain) {
      state.fetching = true

      apiService.getClientProjects(domain)
        .then(response => {
          commit('setProjects', response.data.projects)
          window.vue.$emit('clientProjectsLoaded')

          state.fetching = false
        })
        .catch(() => {
          state.fetching = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список проектов клиента.'
          })
        })
    },
    changeSelectedProjectId ({ commit }, id) {
      commit('setSelectedProjectId', id)
      window.vue.$emit('clientProjectsSelectedProjectIdChange')
    },
    changeSelectedRegion ({ commit }, region) {
      commit('setSelectedRegion', region)
      window.vue.$emit('clientProjectsSelectedRegionChange')
    }
  },
  getters: {
    getCoresListOfSelectedRegion: state => {
      const list = {}

      let index = 1
      for (const project of state.projects) {
        if (!state.selectedRegion || state.selectedRegion === project.region) {
          list[project.id_parent] = `Ядро ${index}`

          index += 1
        }
      }

      return list
    },
    getProjectsOfSelectedRegion: state => {
      return state.projects.filter((project) => project.region === state.selectedRegion)
    },
    getRegions: state => {
      const regions = []

      for (const project of state.projects) {
        regions.push(project.region)
      }

      return [...new Set(regions)]
    },
    getProjectById: state => id => {
      return state.projects.find((project) => project.id_parent === id)
    },
    getSelectedProject: (state, getters) => {
      return getters.getProjectById(state.selectedProjectId)
    },
    isSelectedProjectPromoteBySengine: (state, getters) => (sengine) => {
      const project = getters.getSelectedProject

      return project && project.sengines.includes(sengine)
    }
  }
}
